module.exports = __webpack_public_path__ + "img/camera.2af665e8.png";